import { ORIENTATION } from '../../../../../../../../../services/cards/constants';
import { getThumbBySize } from '../../../../../../../../../util/photo';
import { IMAGE_SIZE_CODE } from '../../../../../../../../../constants/image-size-codes';

/**
 * Determines the orientation of a photo.
 *
 * @param {Object} photo The Photo.
 * @returns {ORIENTATION|ORIENTATION|undefined}
 */
export const getPhotoOrientation = photo => {
  if (!photo?.thumbnail_urls) {
    return undefined;
  }

  const sampleThumbnail = getThumbBySize(
    photo.thumbnail_urls,
    IMAGE_SIZE_CODE.SMALL,
    true,
  );
  const { width, height } = sampleThumbnail;

  return width >= height ? ORIENTATION.LANDSCAPE : ORIENTATION.PORTRAIT;
};

/**
 * Determines the preferred orientation a Photo should be configured in a PrintProduct
 * based on the available orientations on a PrintProductSize and the inherent
 * orientation of the Photo.
 *
 * @param {Object} options The options
 * @param {Object} options.printProductSize The PrintProductSize.
 * @param {Object} options.photo The Photo.
 * @returns {ORIENTATION|ORIENTATION}
 */
export const getPreferredPrintProductSizeOrientation = ({
  printProductSize,
  photo,
}) => {
  if (!printProductSize || !photo) {
    return ORIENTATION.LANDSCAPE;
  }

  const { orientations = [ORIENTATION.LANDSCAPE] } = printProductSize;

  if (orientations.length === 1) {
    return orientations[0];
  }

  return getPhotoOrientation(photo) ?? ORIENTATION.LANDSCAPE;
};
